import { render, staticRenderFns } from "./WorkFlowModal.vue?vue&type=template&id=9b31c252&scoped=true&"
import script from "./WorkFlowModal.vue?vue&type=script&lang=js&"
export * from "./WorkFlowModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowModal.vue?vue&type=style&index=0&id=9b31c252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b31c252",
  null
  
)

export default component.exports